import React from 'react';
import { Box, Typography } from '@mui/material';
import { string } from 'prop-types';

// utils
import { END_DATE_FORMAT } from 'feature/loading-management/utils/const';
import { format } from 'date-fns';

// styles
import { labelTextStyles } from '../SupplierAuthCard.styles';

const SupplierAuthEndDate = ({ endDate }) => {
  const formatSupplierEndDate = (dateFormat, date) => {
    if (!date) return 'N/A';
    const dateOnly = date.split('T')[0];
    if (dateOnly === '2999-12-31') return '--';
    const [year, month, day] = dateOnly.split('-').map(Number);
    return format(new Date(year, month - 1, day), dateFormat);
  };

  return (
    <Box textAlign="center" width={1}>
      <Typography sx={labelTextStyles}>End Date</Typography>
      <Typography>{formatSupplierEndDate(END_DATE_FORMAT, endDate)}</Typography>
    </Box>
  );
};

SupplierAuthEndDate.propTypes = {
  endDate: string,
};

SupplierAuthEndDate.defaultProps = {
  endDate: null,
};

export default SupplierAuthEndDate;
